module.exports = {
  backendLink: 'https://fidia-api.nichepharma.com',
  // backendLink: 'http://localhost:5000',
}
